import {Component, ViewEncapsulation} from '@angular/core';
import {WishListItemComponent} from '@spartacus/cart/wish-list/components';

@Component({
    selector: 'app-uig-wish-list-item',
    templateUrl: './uig-wish-list-item.component.html',
    styleUrls: ['./uig-wish-list-item.component.scss'],
    encapsulation: ViewEncapsulation.None,
    standalone: false
})
export class UigWishListItemComponent extends WishListItemComponent {

}
